import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0c1b7f08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-stepper" }


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseStepper',
  props: {
    total: {},
    current: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.total, (index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: `stepper-${index}`,
        class: _normalizeClass([`base-stepper__item`, { [`base-stepper__item--active`]: index === _ctx.current }])
      }, null, 2))
    }), 128))
  ]))
}
}

})